import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'freePromotion',
    component: () => import('@/views/freePromotion/freePromotion.vue')
  },
  {
    path: '/purposeUrl',
    name: 'purposeUrl',
    component: () => import('@/views/freePromotion/purposeUrl.vue')
  },
  {
    path: '/registrationResult',
    name: 'registrationResult',
    component: () => import('@/views/registrationResult/registrationResult.vue')
  },
  {
    path: '/notRegistra',
    name: 'notRegistra',
    component: () => import('@/views/registrationResult/notRegistra.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
